<main id="main">
    <kokos-header [page]="PagesEnum.SendMail" [title]="'sendmail.title' | i18next"></kokos-header>

    <div class='container-fluid'>
        <kokos-postfach-eingeschraenkt></kokos-postfach-eingeschraenkt>
    </div>
</main>